import { Icons } from '@/assets/icons/icons';
import { cn } from '@/lib/utils';

import { OUTCOME_TEXT_CLASS } from './feedStyles';

import type { FeedRowView } from './feedRowView';

// What a settled row says in its label's place. A to-do or notice marked done shows only a green tick, which keeps
// the words as its name and tooltip
export const FeedOutcome = ({
  outcome,
}: {
  outcome: NonNullable<FeedRowView['outcome']>;
}) =>
  outcome.tick ? (
    <span
      role="img"
      aria-label={outcome.text}
      title={outcome.text}
      data-testid="feed-row-outcome-tick"
      className={cn('flex shrink-0', OUTCOME_TEXT_CLASS[outcome.tone])}
    >
      <Icons.check aria-hidden="true" className="size-[calc(14*var(--ac-u))]" />
    </span>
  ) : (
    <span
      className={cn(
        'min-w-0 truncate text-[length:calc(13*var(--ac-u))]',
        OUTCOME_TEXT_CLASS[outcome.tone]
      )}
    >
      {outcome.text}
    </span>
  );
